import script from "./CarouselFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./CarouselFormDialog.vue?vue&type=style&index=0&id=79cd0954&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cd0954"]])

export default __exports__